var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_297_600",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_297_600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.3077 20.5017C6.80898 20.5017 6.38302 20.3251 6.02982 19.9719C5.67661 19.6187 5.5 19.1928 5.5 18.694V6.00176H4.5V4.50179H8.99997V3.61719H15V4.50179H19.5V6.00176H18.5V18.694C18.5 19.1992 18.325 19.6267 17.975 19.9767C17.625 20.3267 17.1974 20.5017 16.6922 20.5017H7.3077ZM17 6.00176H6.99997V18.694C6.99997 18.7838 7.02883 18.8575 7.08652 18.9152C7.14422 18.9729 7.21795 19.0018 7.3077 19.0018H16.6922C16.7692 19.0018 16.8397 18.9697 16.9038 18.9056C16.9679 18.8415 17 18.771 17 18.694V6.00176ZM9.40385 17.0018H10.9038V8.00176H9.40385V17.0018ZM13.0961 17.0018H14.5961V8.00176H13.0961V17.0018Z",
    fill: "#FF3A3A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.541ed3353bb9fcf288f4a7dfe402c022.svg";
export { ForwardRef as ReactComponent };